import styled from 'styled-components';

export const Container = styled.div`
    overflow: auto;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    align-self: center !important;
    align-items: center !important;
    justify-content: center !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    .div-vermelha {
        width: 100%;
        height: 304px;
        background-color: #d7232c;
        position: relative;
        top: 0;
        right: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-self: center !important;
        align-items: center !important;
        justify-content: center !important;

        @media(max-width: 590px) {
            height: 254px;
        }

        @media(max-width: 360px) {
            height: 204px;
        }

        button {
            position: absolute;
            right: 20px;
            top: 20px;
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;
            font-size: 28px;

            @media(max-width: 360px) {
                right: 10px;
                top: 10px;
            }

            .i-close {
                vertical-align: middle;
                align-self: center;
                font-size: 34px;
                top: 10px;
                bottom: 10px;
                left: 10px;
                right: 10px;
                color: #fff !important;

                @media(max-width: 360px) {
                    font-size: 26px;
                }
            }
        }

        .vector-img {
            position: absolute;
            width: 352px;
            height: 200px;
            bottom: 0px;
            object-fit: contain;
            align-self: center;

            @media(max-width: 360px) {
                width: 260px;
                height: 148px;
            }
        }
    }

    .div-branca {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-self: center !important;
        align-items: center !important;
        justify-content: center !important;

        .div-texto-sucesso {
            margin-top: 72px;
            max-width: 557px;
            width: 60%;

            @media(max-width: 590px) {
                margin-top: 40px;
            }

            h1 {
                margin-top: 68px;
                margin-bottom: 0px;
                overflow: hidden;
                font-family: Montserrat;
                font-size: 32px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #1c0506;
                text-align: center;
                cursor: default;

                @media(max-width: 360px) {
                    margin-top: 0px;
                    font-size: 24px;
                }
            }
        }

        .div-textos {
            margin-top: 72px;
            max-width: 319px;
            width: 85%;

            @media(max-width: 590px) {
                margin-top: 40px;
            }

            h2 {
                margin-top: 0px;
                margin-bottom: 16px;
                overflow: hidden;
                font-family: Montserrat;
                font-size: 32px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #1c0506;
                text-align: center;
                cursor: default;

                @media(max-width: 360px) {
                    font-size: 24px;
                    margin-bottom: 8px
                }
            }

            h3 {
                margin-bottom: 0px;
                margin-top: 0px;
                overflow: hidden;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 2;
                letter-spacing: normal;
                color: #1c0506;
                text-align: center;
                cursor: default;

                @media(max-width: 360px) {
                    font-size: 16px
                }
            }
        }

        .div-input {
            position: relative;
            width: 90%;
            max-width: 557px;
            height: 78px;
            overflow: hidden;
            border-radius: 10px;
            border: 0.25px solid lightgray;
            padding: 0;
            box-sizing: border-box;
            margin-top: 32px;

            @media(max-width: 360px) {
                height: 64px;
            }
        }

        .div-input-focado {
            position: relative;
            width: 90%;
            max-width: 557px;
            height: 78px;
            overflow: hidden;
            border-radius: 10px;
            border: 0.25px solid #1c0506;
            padding: 0;
            box-sizing: border-box;
            margin-top: 32px;

            @media(max-width: 360px) {
                height: 64px;
            }
        }

        .div-input-error {
            position: relative;
            width: 90%;
            max-width: 557px;
            height: 78px;
            overflow: hidden;
            border-radius: 10px;
            border: 0.25px solid #c32027;
            margin-bottom: 8px;
            padding: 0;
            box-sizing: border-box;
            margin-top: 32px;

            @media(max-width: 360px) {
                height: 64px;
            }
        }

        .div-input input {
            font-family: Montserrat;        
            font-size: 16px;
            font-weight: 600;
            width: 90%;
            height: 100%;
            color: #1c0506;
            padding-top: 13px;
            border: none;
            outline: none;
            padding-left: 20px;

            @media(max-width: 360px) {
                padding-top: 8px;
            }
        }

        .div-input-focado input {
            font-family: Montserrat;        
            font-size: 16px;
            font-weight: 600;
            width: 90%;
            height: 100%;
            color: #1c0506;
            padding-top: 13px;
            border: none;
            outline: none;
            padding-left: 20px;

            @media(max-width: 360px) {
                padding-top: 8px;
            }
        }

        .div-input-error input {
            font-family: Montserrat;        
            font-size: 16px;
            font-weight: 500;
            width: 90%;
            height: 100%;
            color: #c42027;
            padding-top: 13px;
            border: none;
            outline: none;
            padding-left: 20px;

            @media(max-width: 360px) {
                padding-top: 8px;
            }
        }

        .div-input label {
            font-family: Montserrat;
            font-weight: 600;
            color: lightgray;
            position: absolute;
            bottom: 20px;
            left: 20px;
            width: 100%;
            height: 100%;
            pointer-events: none;

            @media(max-width: 360px) {
                bottom: 12px;
            }
        }

        .div-input-focado label {
            font-family: Montserrat;
            font-weight: 600;
            color: lightgray;
            position: absolute;
            bottom: 20px;
            left: 20px;
            width: 100%;
            height: 100%;
            pointer-events: none;

            @media(max-width: 360px) {
                bottom: 12px;
            }
        }

        .div-input-error label {
            font-family: Montserrat;
            font-weight: 600;
            color: lightgray;
            position: absolute;
            bottom: 20px;
            left: 20px;
            width: 100%;
            height: 100%;
            pointer-events: none;

            @media(max-width: 360px) {
                bottom: 12px;
            }
        }

        .div-input label::after {
            content: "";
            position: absolute;
            left: 0px;
            bottom: 10px;
            height: 100%;
            width: 100%;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
        }

        .div-input-focado label::after {
            content: "";
            position: absolute;
            left: 0px;
            bottom: 10px;
            height: 100%;
            width: 100%;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
        }

        .div-input-error label::after {
            content: "";
            position: absolute;
            left: 0px;
            bottom: 10px;
            height: 100%;
            width: 100%;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
        }

        .content-name {
            position: absolute;
            bottom: 8px;
            left: 0px;
            transition: all 0.3s ease;
        }

        .div-input input:focus + .label-name .content-name,
        .div-input input:valid + .label-name .content-name {
            transform: translateY(-150%);
            bottom: 0px;
            font-size: 12px;

            .div-input::after {
                border: none;
            }
        }

        .div-input-focado input:focus + .label-name .content-name,
        .div-input-focado input:valid + .label-name .content-name {
            transform: translateY(-150%);
            bottom: 0px;
            font-size: 12px;

            .div-input-focado::after {
                border: none;
            }
        }

        .div-input-error input:focus + .label-name .content-name,
        .div-input-error input:valid + .label-name .content-name {
            transform: translateY(-150%);
            bottom: 0px;
            font-size: 12px;

            .div-input-error::after {
                border: none;
            }
        }

        .div-input input:focus + .label-name::after,
        .div-input input:valid + .label-name::after {
            transform: translateX(0%);
        }

        .div-input-focado input:focus + .label-name::after,
        .div-input-focado input:valid + .label-name::after {
            transform: translateX(0%);
        }

        .div-input-error input:focus + .label-name::after,
        .div-input-error input:valid + .label-name::after {
            transform: translateX(0%);
        }

        .div-input button {
            position: absolute;
            right: 15px;
            top: 20px;
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;
            font-size: 28px;

            :hover {
                opacity: 0.6;
            }
            .i {
                vertical-align: middle;
            }

            @media(max-width: 590px) {
                font-size: 22px;
                top: 25px;
            }
            @media(max-width: 360px) {
                font-size: 18px;
                top: 20px
            }
        }

        .div-input-focado button {
            position: absolute;
            right: 15px;
            top: 20px;
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;
            font-size: 28px;

            :hover {
                opacity: 0.6;
            }
            .i {
                vertical-align: middle;
            }

            @media(max-width: 590px) {
                font-size: 22px;
                top: 25px;
            }
            @media(max-width: 360px) {
                font-size: 18px;
                top: 20px
            }
        }

        .div-input-error button {
            position: absolute;
            right: 15px;
            top: 20px;
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;
            font-size: 28px;

            :hover {
                opacity: 0.6;
            }
            .i {
                vertical-align: middle;
            }

            @media(max-width: 590px) {
                font-size: 22px;
                top: 25px;
            }
            @media(max-width: 360px) {
                font-size: 18px;
                top: 20px
            }
        }

        .div-invalido {
            width: 95%;
            max-width: 540px;
            overflow: hidden;
            box-sizing: border-box;
            top: 0px;

            .texto-invalido {
                font-family: Montserrat;
                font-size: 12px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #c42027;
                float: left;
                cursor: default;
            }
        }

        .div-botao {
        position: relative;
        width: 90%;
        height: 72px;
        max-width: 557px;
        overflow: hidden;
        box-sizing: border-box;
        margin-top: 40px;
        margin-bottom: 40px;

        @media(max-width: 360px) {
                margin-top: 32px;
                height: 48px;
            }

            .botaologin {
            width: 100%;
            height: 100%;
            background-color: lightgrey;
            color: #1c0506;
            object-fit: contain;
            text-align: center;
            font-family: Montserrat;
            font-weight: 700;
            font-size: 14px;
            border-radius: 50px;
            border: none;
            outline: none;
            cursor: pointer;
        }

            .botaologin-active {
            width: 100%;
            height: 100%;
            background-color: #d7232c;
            color: #fff;
            object-fit: contain;
            text-align: center;
            font-family: Montserrat;
            font-weight: 700;
            font-size: 14px;
            border-radius: 50px;
            border: none;
            outline: none;
            cursor: pointer;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
        }

            .botaologin-enviado {
                width: 100%;
                height: 100%;
                background-color: #c32027;
                color: #fff;
                object-fit: contain;
                text-align: center;
                font-family: Montserrat;
                font-weight: 700;
                font-size: 14px;
                border-radius: 50px;
                border: none;
                outline: none;
                cursor: pointer;
                transition: 0.2s;

                :hover {
                    background-color: #9c1a1f
                }

                :active {
                    background-color: #d7232c
                }
            }

            .spinner {
                position: absolute;
                align-self: center;
                justify-content: center;
                top: 28px;
                right: 48%;

                @media(max-width: 360px) {
                    top: 16px;
                    right: 47%;
                }
            }
        }
    }

`